import * as React from "react";
import ImageOne from "../Assets/diet1.jpg";
import ImageTwo from "../Assets/fitness.jpg";
import ImageFour from "../Assets/fitness2.jpg";
import ImageFive from "../Assets/fitness3.jpg";
import ImageSix from "../Assets/fitness4.jpg";
import ImageSeven from "../Assets/GymDesign.png";
import ImageEight from "../Assets/tN4xVgWc.jpeg";
import ImageTen from "../Assets/trx.jpg";
import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useInView } from "react-intersection-observer";

const itemData = [
  {
    img: ImageOne,
    title: "Nutrition Planning",
    info: "Personalized Nutrition Plan built for you and your needs",
  },
  {
    img: ImageTwo,
    title: "Functional Fitness",
    info: "Functional Training with kettlebells, dumbbells, and more!",
  },

  {
    img: ImageFour,
    title: "Strength Training",
    info: "Get stronger and redifine yourself!",
  },
  {
    img: ImageFive,
    title: "Group Training",
    info: "Small Group Training Sessions Available!",
  },
  {
    img: ImageTen,
    title: "TRX Training",
    info: "Functional Training",
  },
  {
    img: ImageSix,
    title: "Olympic Weightlifting",
    info: "Redifine your routine!",
  },
  {
    img: ImageSeven,
    title: "My Studio",
    info: "The Garage Gym",
  },
  {
    imgs: [ImageEight], // Array of images
    titles: ["Your Coach"], // Array of titles
    info: "My passion is to help you reach your goals!", // Info from the first image
  },
];

function CustomCard({ item }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  // Use `useInView` for title and description separately
  const [refTitle, inViewTitle] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const [refInfo, inViewInfo] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  // Define the slide-in animation styles
  const slideInAnimation = {
    animation: `slideIn 0.5s forwards`,
    "@keyframes slideIn": {
      from: { opacity: 0, transform: "translateY(20px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  };

  return (
    <Card
      sx={{
        position: "relative",
        display: "inline-block",
        width: "100%",
        marginRight: "15px",
        marginBottom: 10,
        overflow: "hidden",
        backgroundColor: "black",
        paddingRight: "15px",
        paddingLeft: "15px",
      }}
    >
      {item.imgs ? (
        <Box
          sx={{
            display: "flex",
            width: "100%",

            height: matches ? 600 : 500,
          }}
        >
          {item.imgs.map((img, index) => (
            <CardMedia
              key={index}
              component="img"
              image={img}
              alt={item.titles[index]}
            />
          ))}
        </Box>
      ) : (
        <CardMedia
          component="img"
          sx={{
            width: "100%",
            height: 600,
          }}
          image={item.img}
          alt={item.title}
        />
      )}
      <CardContent
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          padding: "10px",
        }}
      >
        <Typography
          variant="h5"
          component="div"
          ref={refTitle}
          sx={inViewTitle ? slideInAnimation : {}}
        >
          {item.titles ? item.titles.join(" & ") : item.title}
        </Typography>
        {item.info && (
          <Typography
            variant="body2"
            ref={refInfo}
            sx={inViewInfo ? slideInAnimation : {}}
          >
            {item.info}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default function MasonryImageList() {
  return (
    <Box>
      {" "}
      {/* Adjust the color to match your theme */}
      {itemData.map((item, index) => (
        <CustomCard key={index} item={item} />
      ))}
    </Box>
  );
}
